import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-edit-image',
    templateUrl: './edit-image.component.html',
    styleUrls: ['./edit-image.component.scss']
})
export class EditImageComponent {
    @Input() imgSrc: string;
    @Input() title: string

    @Output() removePhotoEmitter: EventEmitter<void> = new EventEmitter<void>();
    @Output() changePhotoEmitter: EventEmitter<void> = new EventEmitter<void>();
    @Output() closeModalEmitter: EventEmitter<void> = new EventEmitter<void>();

    removePhoto() {
        this.removePhotoEmitter.emit();
    }

    changePhoto() {
        this.changePhotoEmitter.emit();
    }

    closeModal() {
        this.closeModalEmitter.emit()
    }
}
